import { InAppMessageEvaluatorRequest } from "./InAppMessageEvaluatorRequest"
import { InAppMessageEvaluatorEvaluation } from "./InAppMessageEvaluatorEvaluation"
import ContextualEvaluator from "../ContextualEvaluator"

export abstract class InAppMessageEvaluator<
  Request extends InAppMessageEvaluatorRequest,
  Evaluation extends InAppMessageEvaluatorEvaluation
> extends ContextualEvaluator<Request, Evaluation> {
  abstract record(request: Request, evaluation: Evaluation): void
}
